import { formatNumberWithCommas } from '@/utils/formatNumber'
import { TooltipContentProps } from 'recharts'

type CustomTooltipProps = TooltipContentProps<number, string> & {
  decimalPlaces?: number
  decimalPlacesSecondary?: number
}

export const CustomTooltip = ({
  active,
  payload,
  label,
  decimalPlaces = 2,
  decimalPlacesSecondary = 2,
}: CustomTooltipProps) => {
  if (!(active && payload && payload.length)) {
    return null
  }

  const primary = payload.find((p) => p.dataKey === 'value1')
  const secondary = payload.find((p) => p.dataKey === 'value2')

  const isComparison = primary || secondary

  return (
    <div className='bg-background border border-border p-2 px-3 rounded shadow-[0_2px_4px_rgba(0,0,0,0.1)]'>
      <p className='m-0 font-semibold mb-1'>
        {payload[0].payload.tooltipLabel ?? payload[0].payload.name ?? label}
      </p>

      {isComparison ? (
        <>
          {primary && (
            <p className='m-0 text-[#82ca9d]'>
              {formatNumberWithCommas(primary.value, {
                minDecimalPlaces: decimalPlaces,
                maxDecimalPlaces: decimalPlaces,
              })}
            </p>
          )}

          {secondary && (
            <p className='m-0 text-[#8884d8]'>
              {formatNumberWithCommas(secondary.value, {
                minDecimalPlaces: decimalPlacesSecondary,
                maxDecimalPlaces: decimalPlacesSecondary,
              })}
            </p>
          )}
        </>
      ) : (
        <p className='m-0 text-[#82ca9d]'>
          {formatNumberWithCommas(payload[0].value, {
            minDecimalPlaces: decimalPlaces,
            maxDecimalPlaces: decimalPlaces,
          })}
        </p>
      )}
    </div>
  )
}
